module.exports = __webpack_public_path__ + "img/news15_2.8668e74d.jpg";